<!-- app/components/common/ResponsiveImage.vue -->
<script setup lang="ts">
interface Props {
  src: string;
  alt: string;
  class?: string;
  loading?: "lazy" | "eager";
  fetchpriority?: "high" | "low" | "auto";
  width?: number;
  height?: number;
}

const props = withDefaults(defineProps<Props>(), {
  class: "",
  loading: "lazy",
  fetchpriority: "auto",
  width: undefined,
  height: undefined,
});

const mobileSrc = computed(() => {
  const ext = props.src.substring(props.src.lastIndexOf("."));
  return props.src.replace(ext, `-mobile${ext}`);
});
</script>

<template>
  <picture>
    <source media="(max-width: 640px)" :srcset="mobileSrc" />
    <img
      :src="props.src"
      :alt="props.alt"
      :class="props.class"
      :loading="props.loading"
      :fetchpriority="props.fetchpriority"
      :width="props.width"
      :height="props.height"
    />
  </picture>
</template>
